import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Picture from 'picture'
import { Icon, Typography } from 'foundations-library/components'
import { getRemoteValue } from './../utils'
import { mfa, mfa_inline } from '../graphics'
import { UserContext } from 'providers'
import MFAButton from '../components/elements/MFAButton'

const jss = (theme) => {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px',
            alignSelf: 'stretch',
            borderRadius: '20px',
            border: '1px solid #FD9A27',
            backgroundColor: '#fff',
            margin: '0 10px'
        },
        picture: {
            width: '100%',
            '& img': {
                width: '100%',
                borderRadius: '20px 20px 0px 0px'
            }
        },
        content: {
            display: 'flex',
            padding: '0px 20px',
            alignItems: 'flex-end',
            gap: '20px',
            alignSelf: 'stretch'
        },
        leftContent: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
            flex: '1 0 0'
        },
        rightContent: {
            display: 'flex',
            padding: '30px 0px 40px 0px',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
            gap: '20px',
            alignSelf: 'stretch',
            borderRadius: '0px 0px 20px 20px',
            '& .mfa-button .loader--inner path': {
                fill: '#fff !important'
            }
        },
        textContainer: {
            display: 'flex',
            paddingBottom: '30px',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '10px',
            flex: '1 0 0'
        }
    }
}
const useStyles = makeStyles(jss)

const texts = getRemoteValue('enable_mfa')

/**
 *
 */
const MFA = ({ date }: { date: string }) => {
    const classes = useStyles()
    const user = useContext(UserContext)
    const isNxtUser = user?.user_tiered
    const isClassicUser = !user?.user_tiered

    return (
        <div className={classes.root}>
            <Picture sources={[{ src: mfa, type: 'image/jpeg' }]} thumbnail={mfa_inline} alt='MFA graphic' attributes={{ className: classes.picture }} />
            <div className={classes.content}>
                <div className={classes.leftContent}>
                    <Icon name='notification-alert' size={30} color='destructive-400' />
                    <div className={classes.textContainer}>
                        <Typography variant='h6'>
                            {texts.title}
                        </Typography>
                        <Typography variant='subtitle2'>
                            {texts.subtitle.replace('{DATE}', new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }))}
                        </Typography>
                        <div>
                            {texts.description.map((item, index) => ((item.user === 'nxt' && isNxtUser) || (item.user === 'classic' && isClassicUser) || (item.user === undefined)) && (
                                <Typography display='inline' variant={item.type} color='neutral-700' key={index}>
                                    {item.value}
                                </Typography>
                            ))}
                        </div>
                    </div>
                </div>
                <div className={classes.rightContent}>
                    <MFAButton>
                        {texts.enable_button}
                    </MFAButton>
                </div>
            </div>
        </div>
    )
}

export default MFA
